import { useContext } from "react";
import { Box, Flex, Text, Progress } from "@chakra-ui/react";
import { AiOutlineInfoCircle } from "react-icons/ai";

// Contexts
import { StakeContext } from "providers/StakeProvider";

// Components
import Tooltip from "components/Tooltip";
import { Props } from "./StakingLimit.types";
import { numberToCurrency } from "utils/common";

const StakingLimit = ({ utilised, percentage }: Props) => {
  const { config, stakingLimitDetails } = useContext(StakeContext);

  const { totalLimit } = stakingLimitDetails;

  return (
    <Box bg="brand.background" mt="1rem" p="1rem" borderRadius="12px">
      <Flex
        alignItems="center"
        justifyContent="space-between"
        fontSize={{ base: "12px", lg: "1rem" }}
        align="center"
        gap="0.5rem"
      >
        <Flex alignItems="center" gap="0.5rem">
          <Text>Staking Limit</Text>
          <Tooltip label="The maximum number of Matic that can be staked at the moment.">
            <AiOutlineInfoCircle />
          </Tooltip>
        </Flex>

        <Box>
          <Text fontFamily="medium">
            {numberToCurrency(utilised.toString())} /{" "}
            {numberToCurrency(totalLimit.toString())}{" "}
            {config.nativeCurrency.symbol} ({percentage}%)
          </Text>
        </Box>
      </Flex>
      <Progress
        bg="brand.backgroundLight"
        mt="0.5rem"
        value={percentage > 100 ? 100 : percentage}
        size="xs"
        colorScheme="pink"
        borderRadius="4px"
        sx={{
          "& > div": {
            background: "linear-gradient(270deg, #7630EC -1%, #E0D0FB 98.22%);",
          },
        }}
      />
    </Box>
  );
};

export default StakingLimit;
